import { MyClubCardsPage } from 'pages/my-cards/MyClubCardsPage';

const MyClubVaultPage = () => {
  return <MyClubCardsPage />;
};
export default MyClubVaultPage;
